// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__6tmn5","hero":"Hero_hero__vzGAq","title":"Hero_title__jA484"};